import { IncomingMessage, ServerResponse } from "http";
import { ConcreteRequest, GraphQLTaggedNode } from "relay-runtime";

import {
  NextInternalRequestMeta,
  IncomingRequestHeaderData,
  FetchQueryReturnType,
} from "@framework/relay/server/query/query-fetcher.types";
import { IncomingNextInternalRequestMeta } from "@framework/relay/shared/Middleware";

/** Extract ConcreteRequest from GraphQLTaggedNode */
export function getConcreteRequest(node: GraphQLTaggedNode): ConcreteRequest {
  let resolve: any = node;
  if ("default" in resolve) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    resolve = resolve.default;
  }
  if (typeof resolve === "function") {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    resolve = resolve();
  }
  if (!("operation" in resolve)) {
    // Should never happen.
    throw new Error("Not a ConcreteRequest");
  }
  return resolve as ConcreteRequest;
}

/** Get identifier for the specific graphql request */
export function getRequestIdentifier(queryName: string, variables: any) {
  return queryName + JSON.stringify(variables);
}

/**
 * Extract Next.js internal request metadata from the incoming request
 * Next.js attaches internal metadata to requests using a Symbol property.
 * This function safely extracts that metadata and returns the relevant fields.
 *
 * @param req - The incoming HTTP request object
 * @returns Object containing Next.js internal metadata (initURL, invokePath, invokeOutput) or undefined if not found
 */
export function getNextInternalRequestMeta(
  req: IncomingMessage,
): IncomingNextInternalRequestMeta | undefined {
  const symbols = Object.getOwnPropertySymbols(req);
  const metaSymbol = symbols.find(
    (sym) => sym.description === "NextInternalRequestMeta",
  );
  if (!metaSymbol) {
    return undefined;
  }

  // Cast to unknown first, then to Record<symbol, unknown>
  const meta = (req as unknown as Record<symbol, unknown>)[metaSymbol];
  if (!meta || typeof meta !== "object") {
    return undefined;
  }
  const metaData = meta as NextInternalRequestMeta;

  return {
    initURL: metaData.initURL,
    invokePath: metaData.invokePath,
    invokeOutput: metaData.invokeOutput,
  };
}

/**
 * Extract specific header values from incoming request headers
 * @param headers - The request headers object
 * @returns Object containing extracted header values
 */
export function extractRequestHeaderData(
  headers: IncomingMessage["headers"],
): IncomingRequestHeaderData {
  return {
    forwardedHost: headers["x-forwarded-host"] as string | undefined,
    resourceNodeId: headers["vm-resource-node-id"] as string | undefined,
    resourceType: headers["vm-resource-type"] as string | undefined,
    resourceWpId: headers["vm-resource-wp-id"] as string | undefined,
  };
}

/**
 * Duration headers are used to store data around the execution time of GQL
 * queries for testing and performance evaluation purposes. This function
 * sets query duration headers on the response object for each query result.
 */
export function setQueryDurationHeaders<T extends FetchQueryReturnType<any>>(
  res: ServerResponse<IncomingMessage>,
  queryResults: T[],
): void {
  queryResults.forEach(({ durationHeaderKey, duration }) => {
    res.setHeader(durationHeaderKey, duration);
  });
}
